import 'css-chunksrc/client/scenes/accountCreationConfirmation/form/accountForm/styles.scss';export default {
  "form": "_form_uanco_1",
  "group": "_group_uanco_8",
  "label": "_label_uanco_12",
  "row": "_row_uanco_18",
  "input": "_input_uanco_29",
  "invalidInput": "_invalidInput_uanco_44"
};